import { mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { _serverUrl2 } from "../../../config";
import { failed } from "../../../Utils/Alerts";
import { getCookie, setCookieInDays } from "../../../Utils/Cookies";
import { loadingSc } from "../../Layout/AlertDiv";
import { tempLayer, zoomToFeatureByXY } from "../../Map/Layers/TempLayer";
import { MyMap } from "../../Map/View/MyMap";

export default function SignDashboard() {
  const history = useHistory();

  const [info, setInfo] = useState([]);
  const [ilce, setIlce] = useState([]);
  const [mahalle, setMahalle] = useState([]);
  const [selectedProje, setSelectedProje] = useState(null);
  const onChangeIlce = async (id) => {
    await axios
      .get(_serverUrl2 + "/main/mah/" + id)
      .then((res) => {
        if (res.data.status) {
          setMahalle(res.data.rows);
        } else {
        }
      })
      .catch(() => {});
  };
  const getInfosFromNode = useCallback(async () => {
    loadingSc(true);
    await axios
      .get(_serverUrl2 + "/main/ilce")
      .then((res) => {
        if (res.data.status) {
          setIlce(res.data.rows);
        } else {
        }
      })
      .catch(() => {});
    if (getCookie("_search_json_d") != "") {
      onSubmitSearch(JSON.parse(getCookie("_search_json_d")));
    }
    await axios
      .get(_serverUrl2 + "/sign/getLastByLimit/50")
      .then((res) => {
        if (res.data.status) {
          setInfo(res.data.rows);
        } else {
          failed("Bilgiler alınırken hata oluştu " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Bilgiler alınırken hata oluştu " + err);
      })
      .finally(() => {
        loadingSc(false);
      });
  }, []);

  const onSubmitSearch = async (pastJson) => {
    loadingSc(true);
    let islem_durum = document.getElementById("islem_durum").value;
    let kontrol_durum = document.getElementById("kontrol_durum").value;
    let tip = document.getElementById("tip").value;
    let ilce = document.getElementById("ilce").value;
    let mahalle = document.getElementById("mahalle").value;
    // let baslangic = document.getElementById('bastar').value
    // let bitis = document.getElementById('bittar').value
    let json;
    if (pastJson == undefined) {
      json = {
        ilce: ilce == 0 ? null : ilce,
        mahalle: mahalle == 0 ? null : mahalle,
        islem_durum: islem_durum == "0" ? null : islem_durum,
        tip: tip == "0" ? null : tip,
        kontrol_durum: kontrol_durum == "0" ? null : kontrol_durum,
        //baslangic,
        //bitis,
      };
    } else {
      json = pastJson;
    }

    setCookieInDays("_search_json_d", JSON.stringify(json));
    await axios
      .post(_serverUrl2 + "/sign/getByFilter", json)
      .then((res) => {
        if (res.data.status) {
          setInfo(res.data.rows);
        } else {
          failed("Hata Oluştu");
        }
      })
      .catch(() => {
        failed("Hata Oluştu");
      })
      .finally(() => {
        loadingSc(false);
      });
  };

  const belgeOlustur = () => {
    let islem_durum = document.getElementById("islem_durum").value;
    let tip = document.getElementById("tip").value;
    let kontrol_durum = document.getElementById("kontrol_durum").value;
    let ilce = document.getElementById("ilce").value;
    let mahalle = document.getElementById("mahalle").value;
    // let baslangic = document.getElementById('bastar').value
    // let bitis = document.getElementById('bittar').value
    let json = {
      ilce: ilce == "0" ? null : ilce,
      mahalle: mahalle == "0" ? null : mahalle,
      islem_durum: islem_durum == "0" ? null : islem_durum,
      tip: tip == "0" ? null : tip,
      kontrol_durum: kontrol_durum == "0" ? null : kontrol_durum,

      //baslangic, bitis
    };
    axios({
      url: _serverUrl2 + "/sign/excel",
      method: "POST",
      data: json,
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "TabloExcel.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  };

  useEffect(() => {
    getInfosFromNode();
    MyMap.addLayer(tempLayer);
    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    };
  }, [getInfosFromNode]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content d-flex justify-content-center">
            <b>Direk/Duvar</b>
          </div>
        </div>
      </div>
      <div className="row textBox" style={{ marginLeft: "3px" }}>
        <div className="col-sm-4">
          <select id="tip" style={{ fontSize: "12px", marginTop: "5px" }} className="form-control form-select">
            <option value="0" disabled selected>
              Tip
            </option>
            <option value="0">HEPSİ</option>
            <option>DİREK</option>
            <option>DUVAR</option>
          </select>
        </div>
        <div className="col-sm-4">
          <select id="islem_durum" style={{ fontSize: "12px", marginTop: "5px" }} className="form-control form-select">
            <option value="0" disabled selected>
              İşlem Durumu
            </option>
            <option value="0">HEPSİ</option>
            <option>YAPILMADI</option>
            <option>TAKILDI</option>
            <option>TAKILAMADI</option>
            <option>HATALI_TAKILDI</option>
          </select>
        </div>
        <div className="col-sm-4">
          <select id="kontrol_durum" style={{ fontSize: "12px", marginTop: "5px" }} className="form-control form-select">
            <option value="0" disabled selected>
              Kontrol Durumu
            </option>
            <option value="0">HEPSİ</option>
            <option>UYGUN</option>
            <option>HATALI</option>
            <option>BEKLEMEDE</option>
          </select>
        </div>

        <div className="col-sm-6">
          <select id="ilce" style={{ fontSize: "12px", marginTop: "5px" }} className="form-control form-select" onChange={(e) => onChangeIlce(e.target.value)}>
            <option value="0" disabled selected>
              İlçe
            </option>
            {ilce.map((d, i) => {
              return (
                <option key={i} value={d.maks_kimlik_no}>
                  {d.ad}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-sm-6">
          <select id="mahalle" style={{ fontSize: "12px", marginTop: "5px" }} className="form-control form-select">
            <option value="0" selected>
              Mahalle
            </option>
            {mahalle.map((d, i) => {
              return (
                <option key={i} value={d.mah_id}>
                  {d.mah_adi}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-sm-8"></div>
        <div className="col-sm-4">
          <button className="greenBtn" onClick={() => onSubmitSearch()} style={{ marginTop: "5px", fontSize: "13px" }}>
            Arama Yap
          </button>
        </div>
        <div className="col-sm-12">&nbsp;</div>
      </div>

      <div className="col-sm-12">
        <div className="textBox">
          <div className="content">
            <table className="table table-hover table-bordered table-sm" style={{ fontSize: "12px", borderRadius: "10px", overflow: "auto" }}>
              <thead>
                <tr>
                  <th style={{ width: "30px" }}></th>
                  <th colSpan={2}>İşlem Durum</th>
                  <th colSpan={1}>Tip</th>
                  <th colSpan={2}>İlçe</th>
                  <th colSpan={2}>Mahalle</th>
                  <th style={{ width: "110px" }}>
                    <button
                      className="darkOrangeBtn col-sm-1"
                      onClick={() => belgeOlustur()}
                      style={{ marginTop: "5px", fontSize: "13px", width: "85px", fontWeight: "bold" }}
                    >
                      Excel
                    </button>
                  </th>
                </tr>
              </thead>

              <tbody>
                {info.map((datum) => {
                  return (
                    <>
                      <tr
                        style={
                          datum.kontrol_durum == "UYGUN"
                            ? { backgroundColor: "rgba(153,187,0,0.21)", borderTop: "2px solid rgba(0,0,0,0.15)", borderRadius: "10px" }
                            : datum.kontrol_durum == "HATALI"
                            ? { backgroundColor: "rgba(248,103,73,0.21)", borderTop: "2px solid rgba(0,0,0,0.15)", borderRadius: "10px" }
                            : { borderTop: "2px solid rgba(0,0,0,0.15)", borderRadius: "10px" }
                        }
                      >
                        <td style={{ borderLeft: "3px solid rgb(160, 202, 140)" }} onClick={() => zoomToFeatureByXY(datum.x, datum.y)}>
                          <Icon path={mdiMapMarker} size={1.5} style={{ color: "#344e75", cursor: "pointer" }} />
                        </td>
                        <td
                          colSpan={2}
                          onClick={() => {
                            selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                          }}
                          style={{ verticalAlign: "middle", fontSize: "10px" }}
                        >
                          {datum.islem_durum}
                        </td>
                        <td
                          colSpan={1}
                          onClick={() => {
                            selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                          }}
                          style={{ verticalAlign: "middle", fontSize: "10px" }}
                        >
                          {datum.tip}
                        </td>
                        <th
                          colSpan={2}
                          onClick={() => {
                            selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                          }}
                          style={{ verticalAlign: "middle", fontSize: "10px" }}
                        >
                          {datum.adres != null && datum.adres != "" && datum.adres.split("-")[0]}
                        </th>
                        <th
                          colSpan={2}
                          onClick={() => {
                            selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                          }}
                          style={{ verticalAlign: "middle", fontSize: "10px" }}
                        >
                          {datum.adres != null && datum.adres != "" && datum.adres.split("-")[1]}
                        </th>

                        <td style={{ verticalAlign: "middle" }}>
                          <center>
                            <button style={{ width: "30px" }} onClick={() => history.push("/dashboard/sign/update/" + datum.id)} className="greenBtn">
                              <i className="fas fa-folder-open"></i>
                            </button>
                            &nbsp;
                            {selectedProje == datum.id ? (
                              <button
                                style={{ width: "20px" }}
                                onClick={() => {
                                  selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                                }}
                                className="greenBtn"
                              >
                                <i className="fas fa-angle-double-up"></i>
                              </button>
                            ) : (
                              <button
                                style={{ width: "20px" }}
                                onClick={() => {
                                  selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                                }}
                                className="whiteBtn"
                              >
                                <i className="fas fa-angle-double-down"></i>
                              </button>
                            )}
                          </center>
                        </td>
                      </tr>
                      {selectedProje == datum.id && (
                        <>
                          <tr style={{ backgroundColor: "rgba(0,0,0,0.05)" }}>
                            <th style={{ borderLeft: "3px solid orange" }} colSpan={3}>
                              Kontrol Durum
                            </th>
                            <td>{datum.kontrol_durum}</td>
                            <th>Kontrol Açıklaması</th>
                            <td colSpan={4}>{datum.kontrol_aciklama}</td>
                          </tr>
                          <tr style={{ backgroundColor: "rgba(0,0,0,0.05)" }}>
                            <th style={{ borderLeft: "3px solid orange" }} colSpan={3}>
                              Saha Açıklaması
                            </th>
                            <td>{datum.aciklama}</td>
                            <th>Adı</th>
                            <td
                              colSpan={4}
                              onClick={() => {
                                selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                              }}
                              style={{ verticalAlign: "middle", fontSize: "10px" }}
                            >
                              {datum.adi}
                            </td>
                          </tr>
                          <tr style={{ backgroundColor: "rgba(0,0,0,0.05)" }}>
                            <th style={{ borderLeft: "3px solid orange" }} colSpan={3}>
                              Veri Kaynağı
                            </th>
                            <td
                              onClick={() => {
                                selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                              }}
                              style={{ verticalAlign: "middle", fontSize: "10px" }}
                            >
                              {datum.veri_kaynagi}
                            </td>
                            <th>Yön Tip</th>
                            <td
                              colSpan={4}
                              onClick={() => {
                                selectedProje == datum.id ? setSelectedProje(0) : setSelectedProje(datum.id);
                              }}
                              style={{ verticalAlign: "middle", fontSize: "10px" }}
                            >
                              {datum.yon_tip}
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
